import isServer from './is-server';

const isOffline = () =>
  !isServer() && window && window.navigator && window.navigator.onLine === false;

export default isOffline;
